import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { AuthProvider } from "./Context/AuthContext";
import "material-icons/iconfont/material-icons.css";
import "material-symbols";
import { ToastContainer } from "react-toastify";
import NotFound from "./pages/notFound";
import MainLayout from "./components/MainLayout";
import { privateRoutes } from "./routes";
import { ProtectedRoute, UnProtectedRoute } from "./Context/ProtectedRoute";
import PropTypes from "prop-types";
import Unauthorized from "./pages/unauthorized";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import SignIn from "./pages/SignIn";

const queryClient = new QueryClient();
// context providers
function RootProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {children}
        <ToastContainer />
      </AuthProvider>
    </QueryClientProvider>
  );
}

RootProvider.propTypes = {
  children: PropTypes.node,
};

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <RootProvider>
     
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
      
      </RootProvider>
    ),
    children: privateRoutes,
  },
  {
    path: "/login",
    element: (
      <RootProvider>
     
          <UnProtectedRoute>
            <SignIn />
          </UnProtectedRoute>
  
      </RootProvider>
    ),
    errorElement: <NotFound />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "unauthorized",
    element: <Unauthorized />,
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
